import React from 'react'

import { Col, Divider, Row } from 'antd'

import { InsurancePremiumDetails } from 'core/application/expenses/getInsurancePremiumDetails'
import { ExpenseStatus } from 'core/domain/expenses/expenseStatus'

import Card from '../../../../common/components/dataDisplay/Card'
import Modal from '../../../../common/components/feedback/Modal'
import Icon from '../../../../common/components/general/Icon'
import { formatMonthAndDateOnly } from '../../../../common/dateFormatters'
import { formatMoney } from '../../../../common/moneyFormatter'

type InsurancePremiumModalProps = {
  insurancePremiumDetails: InsurancePremiumDetails
  onCancel: () => void
  onOk: () => void
  title: string
  status: number
  startDate: string
  endDate: string
}

const InsurancePremiumModal: React.FC<InsurancePremiumModalProps> = (props) => {
  return (
    <Modal visible closable onCancel={props.onCancel} onOk={props.onOk} cancelText={'Close'} title={props.title}>
      <Row gutter={8}>
        <Col span={24}>
          <h6>
            <Icon className="fa fa-money-check-alt mr-8" />
            Amount per month
          </h6>
        </Col>

        <Col span={24}>
          <h4 className="card-amount mb-24">{formatMoney(props.insurancePremiumDetails?.amount)}</h4>
        </Col>

        <Col span={24} className={'mb-24'}>
          <Status expenseStatus={props.status} />
        </Col>
      </Row>

      <Row>
        <Col span={24} className={'insurance-premium-col'}>
          <Card
            title={
              <div className="card-title-text">
                <Icon className="fa fa-calendar-check mr-8" />
                Valid through
              </div>
            }
            className="ant-card-body insurance-premium-modal-card"
            extra={
              <div className="semi-bold">
                {formatMonthAndDateOnly(props.startDate)} - {formatMonthAndDateOnly(props.endDate)}
              </div>
            }
          >
            <Row className="calendar-items-display">
              {props.insurancePremiumDetails?.statusesByMonthDto.length > 0 &&
                props.insurancePremiumDetails?.statusesByMonthDto.map((item) => (
                  <Col span={6} className="pb-8 mt-4">
                    <p>{item.monthShort}</p>
                    {item.status == ExpenseStatus.Verified ? (
                      <Icon className="fa fa-check-circle color-green-6 icon-size" />
                    ) : (
                      <Icon className="fa fa-calendar-check color-gray-7 icon-size" />
                    )}
                  </Col>
                ))}
            </Row>

            <Divider />

            <Row className="pl-24 pb-16">
              <Col span={3} className="mb-8 center-align-items">
                <Icon className="fas fa-check-circle color-green-6 icon-size" />
              </Col>
              <Col span={21} className="mb-8">
                Verified request
              </Col>
              <Col span={3} className="mb-8 center-align-items">
                <Icon className="fa fa-calendar-check color-gray-7 icon-size" />
              </Col>
              <Col span={21} className="mb-8">
                Automatic future request
              </Col>
              <Col span={3} className="mb-8 center-align-items">
                <Icon className="fas fa-exclamation-triangle color-yellow-7 icon-size" />
              </Col>
              <Col span={21} className="mb-8">
                Action required
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Modal>
  )
}

type ExpenseStatusLabelProps = {
  expenseStatus: ExpenseStatus
}

const Status = (props: ExpenseStatusLabelProps) => {
  switch (props.expenseStatus) {
    case ExpenseStatus.Verified:
      return (
        <div>
          <Icon className="fas fa-check color-green-6" />
          Verified for automatic monthly reimbursement.
        </div>
      )
    case ExpenseStatus.Ineligible:
      return (
        <span>
          <Icon className={'fa fa-times mr-4 color-red-6 '} />
          Ineligible for automatic monthly reimbursement.
        </span>
      )
    case ExpenseStatus.ActionRequired:
      return (
        <span>
          <Icon className={'fas fa-exclamation-triangle mr-4 color-yellow-7'} />
          Action required for automatic monthly reimbursement.
        </span>
      )
    default:
      return (
        <div>
          <Icon className={'fa fa-clock mr-4 color-red-3'} />
          Awaiting review{' '}
        </div>
      )
  }
}
export default InsurancePremiumModal
